export default __webpack_public_path__ + "static/media/Starlink_Logo.922899db.svg";